import React from "react";

import {
    Form, Input,
} from 'antd';

import { RegistorClass } from "../core/ComponentRegistor";
import { Menu, Dropdown, Icon, } from 'antd';
const { TextArea } = Input
const { SubMenu } = Menu;
export class AntDropdown extends React.Component<any> {
    state: {
        showHeader: string
    }
    constructor(props) {
        super(props)
        this.state = {
            showHeader: '下拉框',
        }
    }
    render() {
        const { formLayout } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        const menu = (
            <Menu>

                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={() => {
                        this.setState({ showHeader: '1st menu item' })
                    }}>
                        1st menu item</a>
                </Menu.Item>
                <Menu.Item><a target="_blank" rel="noopener noreferrer" onClick={() => {
                    this.itemClick('2ed menu item')
                }}>
                    2ed menu item</a></Menu.Item>

                <SubMenu title="sub menu">
                    <Menu.Item>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.baidu.com/" onClick={() => {
                            this.itemClick('3ed menu item')
                        }}>
                            3st menu item</a>
                    </Menu.Item>
                    <Menu.Item>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.baidu.com/" onClick={() => {
                            this.itemClick('4ed menu item')
                        }}>
                            4st menu item</a>
                    </Menu.Item>
                </SubMenu>
                <SubMenu title="disabled sub menu" disabled>
                    <Menu.Item>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.baidu.com/" onClick={() => {
                            this.itemClick('5ed menu item')
                        }}>
                            5st menu item</a>
                    </Menu.Item>
                    <Menu.Item>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.baidu.com/" onClick={() => {
                            this.itemClick('6ed menu item')
                        }}>
                            6st menu item</a>
                    </Menu.Item>
                </SubMenu>
            </Menu>
        );


        return (
            getFieldDecorator(this.props.formKey, {
                rules: [{
                    validator: this.props.validator
                    // type: this.field.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.props.required, message: '必填项!',
                }],
            })(
                <Dropdown overlay={menu}>
                    <a className="ant-dropdown-link" href="#">
                        {this.state.showHeader}<Icon type="down" />
                    </a>
                </Dropdown>)


        )
    }
    itemClick(item) {
        this.setState({ showHeader: item });
        this.props.itemClick(item)
    }
}

let scheme = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
}
// RegistorClass({
//     componentTag: "Dropdown",
//     componentObject: AntDropdown,
//     componentName: "Ant下拉菜单",
//     scheme: scheme,
//     defaultProps: {
//         span: 12,
//         lable: "下拉菜单",
//         required: false
//     }
// })
// export default AntTextarea